module.exports = __webpack_public_path__ + "static/img/base_banner.5d23c914.png";